import { useMemo } from 'react'
import { useGetModelTreeQuery, useGetProjectQuery } from '../../../../services/projectsApi'
import { useAppSelector } from '../../../../store/hooks'
import { selectSelectedProjectId } from '../../../../store/slices/projectSlice'

export function useModelCatalogData() {
  const selectedProjectId = useAppSelector(selectSelectedProjectId)
  const { data: project } = useGetProjectQuery(selectedProjectId || '', {
    skip: !selectedProjectId,
  })
  const { data: modelTree, isLoading } = useGetModelTreeQuery(selectedProjectId || '', {
    skip: !selectedProjectId,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    pollingInterval: 60000,
  })

  const flatNodes = useMemo(() => {
    function flatten(nodes: any[] = []): any[] {
      let result: any[] = []
      for (const node of nodes) {
        result.push(node)
        if (node.children && node.children.length > 0) {
          result = result.concat(flatten(node.children))
        }
      }
      return result
    }
    return modelTree?.model_tree ? flatten(modelTree.model_tree) : []
  }, [modelTree])

  const organize = useMemo(() => {
    return (nodes: any[]) => {
      const parentModels = nodes.filter((node) => !node.parent_id)
      const branchModels = nodes.filter(
        (node) => node.parent_id && node.children && node.children.length > 0
      )
      const leafModels = nodes.filter(
        (node) => node.parent_id && (!node.children || node.children.length === 0)
      )
      return { parentModels, branchModels, leafModels }
    }
  }, [])

  return { project, modelTree, isLoading, flatNodes, organize }
}
